module.exports = __webpack_public_path__ + "img/qr-code-wxsubscription2x.917dfd61.png";